import Loading from "@lhd/components/Loading";
import { useGetAuth, useGetPermissions } from "@lhd/hooks";
import { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Redirect from "./Redirect";
import { ROUTES } from "@lhd/constants";

type IProps = {
  condition: boolean;
  isLoading?: boolean;
  redirectTo: string;
  children: ReactNode;
  specialRoute?: boolean;
};

const ProtectedRoutes: FC<IProps> = ({
  condition,
  redirectTo,
  children,
  isLoading,
  specialRoute,
}) => {
  const location = useLocation();
  const permissions = useGetPermissions();
  const { isUserResigned } = useGetAuth();
  const loading = isLoading !== undefined ? isLoading : permissions.isLoading;
  const target = location.state?.fallback || redirectTo;

  if (isUserResigned && !specialRoute) {
    return <Redirect to={`/${ROUTES.NOT_FOUND_PAGE}`} />;
  }
  if (loading) return <Loading />;
  if (condition) return <>{children}</>;
  return <Redirect to={target} />;
};

export default ProtectedRoutes;
